import { render, staticRenderFns } from "./materialDialog.vue?vue&type=template&id=0b25fa28&scoped=true"
import script from "./materialDialog.vue?vue&type=script&lang=js"
export * from "./materialDialog.vue?vue&type=script&lang=js"
import style0 from "./materialDialog.vue?vue&type=style&index=0&id=0b25fa28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25fa28",
  null
  
)

export default component.exports